import { PilotEntity } from 'src/store/pilot/pilot.model';

export enum PrdProcessingState {
  Draft = 'Draft',
  Queued = 'Queued',
  ReadyForTransmission = 'ReadyForTransmission',
  TransmissionInProgress = 'TransmissionInProgress',
  TransmissionError = 'TransmissionError',
  NotProcessed = 'NotProcessed',
  ProcessedWithError = 'ProcessedWithError',
  Processed = 'Processed',
}

export class PilotViewModel implements PilotEntity {
  public id: string;
  public airCarrierId: string;
  public certificateNumber: string;
  public firstName: string;
  public middleName: string;
  public lastName: string;
  public hidden: boolean;
  public processingState: PrdProcessingState;
  public lastProcessedDate: Date;
  public processingError: string;

  constructor(pilot: PilotEntity) {
    Object.assign(this, pilot);
  }
}
